<template>
  <div class="flex flex-col gap-32">
    <div class="bg-surface-default-low">
      <BuybackBreadcrumb class="mb-32" productName="product short name" />
      <SeoHero :price productName="product short name" />
    </div>
    <BuybackReassurance />
    <BuybackSearch @item-selected="handleItemSelected" />
    <BuybackCategories @category-click="handleCategoryClick" />
    <div class="bg-surface-default-low">placeholder links</div>
  </div>
</template>

<script setup lang="ts">
import { navigateTo } from '#imports'

import type { Price } from '@backmarket/http-api'
import type { BuybackProduct } from '@backmarket/nuxt-layer-buyback/types'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import BuybackBreadcrumb from '~/scopes/buyback/components/BuybackBreadcrumb/BuybackBreadcrumb.vue'
import BuybackCategories from '~/scopes/buyback/components/BuybackCategories/BuybackCategories.vue'
import BuybackReassurance from '~/scopes/buyback/components/BuybackReassurance/BuybackReassurance.vue'
import BuybackSearch from '~/scopes/buyback/components/BuybackSearch/BuybackSearch.vue'
import SeoHero from '~/scopes/buyback/components/SeoHero/SeoHero.vue'
import { ROUTE_NAMES } from '~/scopes/buyback/constants'

const price: Price = {
  amount: '149.99',
  currency: 'EUR',
}

async function handleItemSelected(item: BuybackProduct) {
  const query = {
    brand: item.brand,
    model: item.model,
    model_family: item.productLine,
    nextStep: 'false',
  }

  const linkParams = {
    name: ROUTE_NAMES.DEVICE_ASSESSMENT,
    type: 'internal',
    params: { slug: item.category, id: item.category },
    query: removeEmptyValuesInObject(query),
  }

  const link = toNuxtLink(linkParams)

  await navigateTo(link)
}

async function handleCategoryClick(categoryName: string) {
  switch (categoryName) {
    case 'iphone':
      await navigateTo({
        name: ROUTE_NAMES.DEVICE_ASSESSMENT,
        params: { slug: 'smartphone', id: 'smartphone' },
        query: { nextStep: 'false', brand: 'Apple' },
      })
      break
    default:
      await navigateTo({
        name: ROUTE_NAMES.DEVICE_ASSESSMENT,
        params: { slug: categoryName, id: categoryName },
        query: { nextStep: 'false' },
      })
      break
  }
}
</script>
